import Filter from './filter';

const container = document.query('.slx-products');
let filter = null;

function init() {
	if(document.query('.slx-products--refresh') === container) {
		filter = new Filter({
			el: container,
			filterContainer: 'slx-filterRefresh',
			allElementsCounterContainer: 'slx-filterRefresh__allElementCounter',
			allElementsCounterButton: 'slx-filterRefresh__seeElementsButton',
		});
	} else {
		filter = new Filter({
			el: container
		});
	}
	filter.start();
}

if (container) {
	init();
}


// Magic fix for hover/touch effect of products items on touch screens
// Without, mouseover (:hover in css) won't trigger
document.queryAll('.slx-products-item').forEach((item) => {
	item.addEventListener('click', () => {
	});
});
